<!-- Side Nav Bar -->
<div class="side-nav d-flex flex-column {{role}}">
  <div class="profile d-flex align-items-center">
    <!-- <img src="assets/images/profile.png" alt="Profile Photo" class="img-fluid profile-img" width="48" height="48" /> -->
    <div class="name">
      <h4>	{{fullUserName}}</h4>
      <h6>{{role}}</h6>
    </div>

    <!-- Header More Actions -->

    <!--
    <div class="more ml-auto">
      <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <img src="assets/images/more-action.svg" alt="More Actions" />
      </a>
      <div class="dropdown-menu">
        <a href="" class="dropdown-item">View Profile</a>
        <a (click)="logout()" class="dropdown-item">Log Out</a>
      </div>
    </div>
    -->

    <!-- Header More Actions -->

  </div>
  <div class="nav-items">
    <ul *ngFor="let i of menuList">
      <li *ngIf="!i.hasOwnProperty('subMenu')" (click)="inactiveClass()"   [ngClass]="getClassSpan(i.achorValue)" id="{{i.name}}"><a   routerLink="{{i.achorValue}}">{{i.name}}</a></li>

      <li *ngIf="i.hasOwnProperty('subMenu')" class="hasMenu" [ngClass]="activeClass?'active':''">
        <a data-toggle="collapse" href="#{{i.name}}" class="collapsed"  aria-expanded="false" [attr.aria-controls]=i.name>
          {{i.name}}
        </a>
        <!-- Mega Dropdown -->
        <ul  class="collapse" [ngClass]="activeClass?'show':''" id="{{i.name}}">
          <!-- <div > -->
            <li (click)="getActive(sub.achorValue)" *ngFor="let sub of i.subMenu"  [ngClass]="getClassSpan(sub.achorValue)" ><a routerLink={{sub.achorValue}}>{{sub.name}}</a></li>
          <!-- </div> -->
        </ul>
      </li>
    </ul>
  </div>
  <div class="d-flex flex-column mt-auto">
    <a href="#!" class="text-danger" (click)="logout()"
      style="font-size: 15px;padding: 15px 20px;margin-bottom: 40px;border-bottom: 1px solid #d1d1d1;border-top: 1px solid #d1d1d1;">Log
      Out</a>
      <img src="assets/images/logo.png" alt="Diagnostic Learning Services" class="img-fluid logo" width="170"/>
  </div>
</div>
